import React, { Component } from 'react';

import './awards.scss';

class Awards extends Component {
    render() {
        return (
            <div className="awards reviews">
                <h1>Reviews &amp; Awards</h1>
                <div className="content-container centered-text">
                    <div className="awards-images">
                        <a href="https://www.weddingwire.com/biz/206-events-seattle/430f0084a64cd9f0.html" target="_blank">
                            <img src="https://cdn1.weddingwire.com/assets/img/en_US/badges/2019-en_US.png" className="wedding-wire-award" alt="206 Events, 2019 Wedding Wire Couples Choice" />
                        </a>
                        <a href="https://www.weddingwire.com/biz/206-events-seattle/430f0084a64cd9f0.html" target="_blank">
                            <img src="https://cdn1.weddingwire.com/assets/img/en_US/badges/2018-en_US.png"
                        className="wedding-wire-award" alt="206 Events, 2018 Wedding Wire Couples Choice" />
                        </a>
                        <a href="https://www.weddingwire.com/biz/206-events-seattle/430f0084a64cd9f0.html" target="_blank">
                            <img src="https://cdn1.weddingwire.com/assets/img/en_US/badges/2017-en_US.png"
                        className="wedding-wire-award" alt="206 Events, 2018 Wedding Wire Couples Choice" />
                        </a>
                        <a href="https://www.weddingwire.com/biz/206-events-seattle/430f0084a64cd9f0.html" target="_blank">
                            <img src="https://cdn1.weddingwire.com/assets/img/en_US/badges/2016-en_US.png"
                        className="wedding-wire-award" alt="206 Events, 2018 Wedding Wire Couples Choice" />
                        </a>
                        <a href="https://www.weddingwire.com/biz/206-events-seattle/430f0084a64cd9f0.html" target="_blank">
                            <img src="https://cdn1.weddingwire.com/assets/img/en_US/badges/2015-en_US.png"
                        className="wedding-wire-award" alt="206 Events, 2018 Wedding Wire Couples Choice" />
                        </a>
                        <a href="https://www.weddingwire.com/biz/206-events-seattle/430f0084a64cd9f0.html" target="_blank">
                            <img src="https://cdn1.weddingwire.com/assets/img/en_US/badges/2014-en_US.png" className="wedding-wire-award" alt="206 Events, 2018 Wedding Wire Couples Choice" />
                        </a>
                    </div>
                    <p>206 Events is proud to have been awarded WeddingWire's Couples Choice Awards for our exceptional service and customer ratings for the past 6 years in a row. Thank you to all of our clients who helped us reach this achievement!</p>
                    <p className="more-reviews">More reviews on: <a href="https://www.weddingwire.com/biz/206-events-seattle/430f0084a64cd9f0.html" target="_blank">Wedding Wire</a><a href="https://www.google.com/search?q=206+events&oq=206+events&aqs=chrome..69i57j69i60l3.1665j0j1&sourceid=chrome&ie=UTF-8#lrd=0x549010f46116a829:0x4df91d8dd8f33094,1,,," target="_blank">Google</a><a href="https://www.yelp.com/biz/206-events-seattle-2" target="_blank">Yelp</a></p>
                </div>
            </div>
        );
    }
}

export default Awards;